import React from 'react';

import Change from '../../../components/Change/Change';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol4ModelDate } from '../../../core/models/tables';

interface INbmFlowTable {
  data: TableCol4ModelDate;
}

export default function NbmFlowTable({ data }: INbmFlowTable): JSX.Element {
  return (
    <div className="NbmFlowTable">
      <h3>NBP Current System & Flow Rates (Mcm/d)</h3>
      <div className="table-container">
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th style={{ width: '34%' }}>Flow Source</th>
              <th style={{ width: '22%' }}>
                {data.date1} <sub>(1)</sub>
              </th>
              <th style={{ width: '22%' }}>
                {data.date2} <sub>(2)</sub>
              </th>
              <th style={{ width: '20%' }}>Change</th>
            </tr>
          </thead>
          <tbody>
            {data.systemTable.map((row, index) => {
              if (row === null) {
                return null;
              }

              return (
                <tr key={index}>
                  <td>
                    {row.col1} {row.col1.includes('Storage net') ? <sub>(3)</sub> : null}
                  </td>
                  {/* <td>{row.col1}##</td> */}
                  <td>{formatNumber(row.col2)}</td>
                  <td>{formatNumber(row.col3)}</td>
                  <td>
                    <Change value={row.col4} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
